import { theme } from "../../styles/styles"
import moment from "moment"
import { getCompleteAccountNumber } from "../../config/payments"

export const emailInlineHTML = (title: string, preheader: string, content: string) =>
  `<!doctype html>
<html lang="cs">
<head>
    <meta name="viewport" content="width=device-width">
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <title>${title}</title>
    <style>
        /* -------------------------------------
            INLINED WITH htmlemail.io/inline
        ------------------------------------- */
        /* -------------------------------------
            RESPONSIVE AND MOBILE FRIENDLY STYLES
        ------------------------------------- */
        @media only screen and (max-width: 620px) {
            table[class=body] h1 {
                font-size: 28px !important;
                margin-bottom: 10px !important;
            }
            table[class=body] p,
            table[class=body] ul,
            table[class=body] ol,
            table[class=body] td,
            table[class=body] span,
            table[class=body] a {
                font-size: 16px !important;
            }
            table[class=body] .wrapper,
            table[class=body] .article {
                padding: 10px !important;
            }
            table[class=body] .content {
                padding: 0 !important;
            }
            table[class=body] .container {
                padding: 0 !important;
                width: 100% !important;
            }
            table[class=body] .main {
                border-left-width: 0 !important;
                border-radius: 0 !important;
                border-right-width: 0 !important;
            }
            table[class=body] .btn table {
                width: 100% !important;
            }
            table[class=body] .btn a {
                width: 100% !important;
            }
            table[class=body] .img-responsive {
                height: auto !important;
                max-width: 100% !important;
                width: auto !important;
            }
        }

        /* -------------------------------------
            PRESERVE THESE STYLES IN THE HEAD
        ------------------------------------- */
        @media all {
            .ExternalClass {
                width: 100%;
            }
            .ExternalClass,
            .ExternalClass p,
            .ExternalClass span,
            .ExternalClass font,
            .ExternalClass td,
            .ExternalClass div {
                line-height: 100%;
            }
            .apple-link a {
                color: inherit !important;
                font-family: inherit !important;
                font-size: inherit !important;
                font-weight: inherit !important;
                line-height: inherit !important;
                text-decoration: none !important;
            }
            #MessageViewBody a {
                color: inherit;
                text-decoration: none;
                font-size: inherit;
                font-family: inherit;
                font-weight: inherit;
                line-height: inherit;
            }
            .btn-primary table td:hover {
                background-color: ${theme.colors["main-color-blue"]} !important;
                color: white;
            }
            .btn-primary a:hover {
                background-color: ${theme.colors["main-color-blue"]} !important;
                border-color: ${theme.colors["main-color-blue"]} !important;
                color: white;
            }
        }
    </style>
</head>
<body class="" style="background-color: #F0F0F0; font-family: sans-serif; -webkit-font-smoothing: antialiased; font-size: 14px; line-height: 1.4; margin: 0; padding: 0; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%;">
<span class="preheader" style="color: transparent; display: none; height: 0; max-height: 0; max-width: 0; opacity: 0; overflow: hidden; mso-hide: all; visibility: hidden; width: 0;">${preheader}</span>
<table border="0" cellpadding="0" cellspacing="0" class="body" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; background-color: #F0F0F0;">
    <tr>
        <td style="font-family: sans-serif; font-size: 14px; vertical-align: top;">&nbsp;</td>
        <td class="container" style="font-family: sans-serif; font-size: 14px; vertical-align: top; display: block; Margin: 0 auto; max-width: 580px; padding: 10px; width: 580px;">
            <div class="content" style="box-sizing: border-box; display: block; Margin: 0 auto; max-width: 580px; padding: 10px;">

                <!-- START CENTERED WHITE CONTAINER -->
                <table class="main" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; background: #ffffff;">

                    <!-- START MAIN CONTENT AREA -->
                    <tr>
                        <td class="wrapper" style="font-family: sans-serif; font-size: 14px; vertical-align: top; box-sizing: border-box; padding: 20px;">
                            <table border="0" cellpadding="0" cellspacing="0" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%;">
                                <tr>
                                    <td style="font-family: sans-serif; font-size: 14px; vertical-align: top; margin: 0 auto; text-align: center; display:block; width: 258px;">
                                        <a href="https://vzdelanibudoucnosti.cz/?utm_source=registration&utm_medium=email&utm_campaign=HTMLemail" target="_blank">
                                            <img width="258" alt="vzdelanibudoucnosti-logo.png" src="cid:vzdelanibudoucnosti-logo" style="display:block; width: 258px;"/>
                                        </a>
                                    </td>
                                </tr>
                                
                                <tr>
                                    <td style="font-family: sans-serif; font-size: 14px; vertical-align: top; margin: 0 auto; text-align: center; display:block; height: 40px;">
                                    </td>
                                </tr>
                            
                                <tr>
                                    <td style="font-family: sans-serif; font-size: 14px; vertical-align: top;">
                                        ${content}
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    <tr>
                        <td class="wrapper" style="font-family: sans-serif; font-size: 14px; vertical-align: top; box-sizing: border-box; padding: 0px;">
                            <table border="0" cellpadding="0" cellspacing="0" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%;" width="100%">
                                <tr>
                                    <td align="center" style="font-size:0px;padding:4px 4px 8px 4px;word-break:break-word;">
                                        <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td><![endif]-->
                                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                                            <tbody>
                                                <tr>
                                                    <td style="padding:4px;">
                                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;/* width: 100%; */">
                                                            <tbody>
                                                                <tr>
                                                                    <td style="padding:5px;font-size:0;height:35px;vertical-align:middle;width:35px;">
                                                                        <a href="https://www.facebook.com/vzdelanibudoucnosti" target="_blank" style="color: ${
                                                                          theme.colors["main-color-blue"]
                                                                        };">
                                                                            <img height="35" alt="facebook-logo.png" src="cid:facebook-logo" style="border-radius:3px;display:block;" width="35">
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <!--[if mso | IE]></td><td><![endif]-->
                                        
                                        <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td><![endif]-->
                                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                                            <tbody>
                                                <tr>
                                                    <td style="padding:4px;">
                                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;/* width: 100%; */">
                                                            <tbody>
                                                                <tr>
                                                                    <td style="padding:5px;font-size:0;height:35px;vertical-align:middle;width:35px;">
                                                                        <a href="https://www.instagram.com/vzdelanibudoucnosti/" target="_blank" style="color: ${
                                                                          theme.colors["main-color-blue"]
                                                                        };">
                                                                            <img height="35" alt="instagram-logo.png" src="cid:instagram-logo" style="border-radius:3px;display:block;" width="35">
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <!--[if mso | IE]></td><td><![endif]-->
                                        
                                        <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td><![endif]-->
                                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                                            <tbody>
                                                <tr>
                                                    <td style="padding:4px;">
                                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;/* width: 100%; */">
                                                            <tbody>
                                                                <tr>
                                                                    <td style="padding:5px;font-size:0;height:35px;vertical-align:middle;width:35px;">
                                                                        <a href="https://www.youtube.com/channel/UCo_bRS8x2_oYv78lEj52lUw" target="_blank" style="color: ${
                                                                          theme.colors["main-color-blue"]
                                                                        };">
                                                                            <img height="35" alt="youtube-logo.png" src="cid:youtube-logo" style="border-radius:3px;display:block;" width="35">
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <!--[if mso | IE]></td><td><![endif]-->           
                                        
                                        <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td><![endif]-->
                                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                                            <tbody>
                                                <tr>
                                                    <td style="padding:4px;">
                                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;/* width: 100%; */">
                                                            <tbody>
                                                                <tr>
                                                                    <td style="padding:5px;font-size:0;height:35px;vertical-align:middle;width:35px;">
                                                                        <a href="https://www.tiktok.com/@vzdelanibudoucnosti?_t=8ij2BsdkGK9&_r=1" target="_blank" style="color: ${
                                                                          theme.colors["main-color-blue"]
                                                                        };">
                                                                            <img height="35" alt="tiktok.png" src="cid:tiktok" style="border-radius:3px;display:block;" width="35">
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <!--[if mso | IE]></td><td><![endif]-->      
                                                             
                                        <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td><![endif]-->
                                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                                            <tbody>
                                                <tr>
                                                    <td style="padding:4px;">
                                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;/* width: 100%; */">
                                                            <tbody>
                                                                <tr>
                                                                    <td style="padding:5px;font-size:0;height:35px;vertical-align:middle;width:35px;">
                                                                        <a href="https://www.linkedin.com/company/vzdelani-budoucnosti-zs/" target="_blank" style="color: ${
                                                                          theme.colors["main-color-blue"]
                                                                        };">
                                                                            <img height="35" alt="linkedin.png" src="cid:linkedin" style="border-radius:3px;display:block;" width="35">
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <!--[if mso | IE]></td><td><![endif]-->                                                                
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <!-- END MAIN CONTENT AREA -->
                </table>

                <!-- START FOOTER -->
                <div class="footer" style="clear: both; Margin-top: 10px; text-align: center; width: 100%;">
                    <table border="0" cellpadding="0" cellspacing="0" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%;">
                        <tr>
                            <td class="content-block powered-by" style="font-family: sans-serif; vertical-align: top; padding-bottom: 10px; padding-top: 10px; font-size: 12px; color: #999999; text-align: center;">
                                Vytvořil <a href="https://vzdelanibudoucnosti.cz/?utm_source=registration&utm_medium=email&utm_campaign=HTMLemail" style="color: #999999; font-size: 12px; text-align: center; text-decoration: none;">Vzdělání budoucnosti team</a>.
                            </td>
                        </tr>
                        <tr>
                            <td class="content-block powered-by" style="font-family: sans-serif; vertical-align: top; padding-bottom: 10px; padding-top: 10px; font-size: 12px; color: #999999; text-align: center;">
                                Naše e-mailová adresa je: <a href="mailto:info@vzdelanibudoucnosti.cz" style="color: #999999; font-size: 12px; text-align: center; text-decoration: none;">info@vzdelanibudoucnosti.cz</a>.
                            </td>
                        </tr>
                        <tr>
                            <td class="content-block powered-by" style="font-family: sans-serif; vertical-align: top; padding-bottom: 10px; padding-top: 10px; font-size: 12px; color: #999999; text-align: center;">
                                Tento e-mail jste obdrželi, protože jste se zaregistrovali na našich webových stránkách vzdelanibudoucnosti.cz nebo pythongo.cz, provedli registraci kurzu, nebo jste uskutečnili nákup na našem e-shopu. Tento e-mail byl pravděpodobně vygenerován automaticky, naším systémem. Odpovědí na něj, odpovíte na naši e-mailovou adresu info@vzdelanibudoucnosti.cz.
                            </td>
                        </tr>
                        <tr>
                            <td class="content-block powered-by" style="font-family: sans-serif; vertical-align: top; padding-bottom: 10px; padding-top: 10px; font-size: 12px; color: #999999; text-align: center;">
                                Vzdělání budoucnosti z.s.<br>
                                L 72272 vedená u Městského soudu v Praze<br>
                                adresa, sídlo: Donská 245/14, Vršovice, 101 00 Praha<br>
                                IČO: 08334463<br>
                                Telefon: (+420) 774 889 639<br>
                                E-mail: <a href="mailto:info@vzdelanibudoucnosti.cz" style="color: #999999; text-decoration: none;">info@vzdelanibudoucnosti.cz</a><br>
                                Bankovní účet: ${getCompleteAccountNumber()}
                            </td>
                        </tr>                        
                        <tr>
                            <td class="content-block powered-by" style="font-family: sans-serif; vertical-align: top; padding-bottom: 10px; padding-top: 10px; font-size: 12px; color: #999999; text-align: center;">
                                Copyright © ${moment().format("YYYY")} Vzdělání budoucnosti, z.s., Všechna práva vyhrazena.
                            </td>                            
                        </tr>
                    </table>
                </div>
                <!-- END FOOTER -->

                <!-- END CENTERED WHITE CONTAINER -->
            </div>
        </td>
        <td style="font-family: sans-serif; font-size: 14px; vertical-align: top;">&nbsp;</td>
    </tr>
</table>
</body>
</html>`
